import React, { Component } from 'react';
import './appheader.css';

import { olapicSSOClient } from 'olapic-sso-client';

class AppHeader extends Component {
  constructor() {
    super();

    this.state = {
      accountName: olapicSSOClient.getSession().account.name,
    };
  }

  switchAccount() {
    olapicSSOClient.switchAccount();
  }

  render() {
    return (
      <header className="App-header">
        <section className="App-header-logocontainer">
          <a href="/" className="App-header-logo">
            Olapic
          </a>
          <span className="App-header-tagline">Email Studio</span>
        </section>
        <section>
          <span className="App-header-session">
            Currently logged into: {this.state.accountName} <button onClick={this.switchAccount}>Switch Account</button>
          </span>
        </section>
      </header>
    );
  }
}

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/AppHeader/appheader.js